// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vfw4","selected":"styles_selected__16Iqb"};